<script lang="ts">
	import Input from "@components/form/Input.svelte";
	import Labelled from "@components/form/Labelled.svelte";
	import type { ComponentProps, Snippet } from "svelte";
	import type { ClassValue, HTMLLabelAttributes } from "svelte/elements";
	import { tw } from "@core/utils/svelte/tw.js";

	let {
		value = $bindable(),
		group = $bindable(),
		checked = $bindable(),
		/* eslint-disable prefer-const */
		wrapperClass,
		label,
		children,
		...rest
		/* eslint-enable prefer-const */
	}: ComponentProps<typeof Input> & {
		wrapperClass?: ClassValue;
		children: Snippet;
		label?: HTMLLabelAttributes;
	} = $props();

	const uniqueId = $props.id();
	const id = $derived(`${rest.id ?? rest.name ?? ""}-${uniqueId}`);
	const isRadioOrCheckbox = $derived(["checkbox", "radio"].includes(String(rest.type)));
	const labelClass = $derived(
		tw(
			label?.class,
			isRadioOrCheckbox
				? ["select-none", rest.disabled === true ? "cursor-not-allowed" : "cursor-pointer"]
				: "text-fcrgray text-sm/6 font-medium",
		),
	);
</script>

<Labelled
	wrapperClass={[wrapperClass, "has-[:disabled]:opacity-50 has-[:disabled]:cursor-not-allowed"]}
	required={rest.required}
	label={{ ...label, class: labelClass, for: id }}
	horizontal={isRadioOrCheckbox}
>
	{@render children()}
	{#snippet content()}
		{#if rest.type === "checkbox" || rest.type === "radio"}
			<Input {...rest} {id} bind:checked bind:group {value} />
		{:else}
			<Input {...rest} {id} bind:value />
		{/if}
	{/snippet}
</Labelled>
